module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (16).ed27a5e1.jpg";